// extracted by mini-css-extract-plugin
export default {"container":"tK-z","topReviewHeading":"uK-z","criticalReview":"vK-z","favorableReview":"wK-z","vsSeparator":"xK-z"};